import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import {
  StyledImageContainer,
  StyledScore,
  StyledSubTitle,
  StyledTitle,
} from "../../../components/ModalComponents/StyledModalComponents";
import ContainedButton from "../../../components/Buttons/ContainedButton";
import styled from "styled-components";

import {
  currentlyEditingSleeperSelector,
  isIncorporateModalOpenSelector,
  setIsIncorporateModalOpen,
} from "../../../redux/slices/customNavigation";
import { getAdaptiveFontSize } from "../../../utils/styling.utils";
import { getFirstName, getLayerString } from "../../../utils/bedBuilder.utils";
import {
  isSingleSleeperSelector,
  primarySleeperBmiSelector,
  secondarySleeperBmiSelector,
} from "../../../redux/slices/mattressConfiguration";
import EvrScore from "../../../components/ModalComponents/EvrScore";
import svg_background from "../../../assets/images/Path_7821.png";

import useMediaQuery from "@mui/material/useMediaQuery";

const StyledTextContainer = styled.div`
  width: 35vw;
  height: 5vh;
  position: absolute;
  padding-left: 8vw;
  padding-right: 5vw;
  margin-top: -39vh;
`;

const EvrRatioModal = ({ showFinalScore = false }) => {
  const { t } = useTranslation();

  const isIncorporateModalOpen = useSelector(isIncorporateModalOpenSelector);
  const primarySleeperBMI = useSelector(primarySleeperBmiSelector);
  const secondarySleeperBMI = useSelector(secondarySleeperBmiSelector);
  const isSingleSleeper = useSelector(isSingleSleeperSelector);

  const currentlyEditingSleeper = useSelector(currentlyEditingSleeperSelector);

  const editingSleeper1 = currentlyEditingSleeper === 1;
  const bmi =
    isSingleSleeper || editingSleeper1
      ? primarySleeperBMI
      : secondarySleeperBMI;

  const theme = useTheme();
  const dispatch = useDispatch();
  //Media Queries
  const isSmallScreen = useMediaQuery("(min-width: 500px)");
  const isMediumScreen = useMediaQuery("(min-width: 768px)");
  const isLargeScreen = useMediaQuery("(min-width: 992px)");
  const isExtraLargeScreen = useMediaQuery("(min-width: 1200px)");
  const screenWidthHooks = {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isExtraLargeScreen,
  };

  return (
    <div
      className="col-5"
      style={{
        position: "relative",
        marginTop: isExtraLargeScreen ? "" : "25vh",
      }}
    >
      <StyledImageContainer className="mx-auto">
        <img
          style={{
            width: "35vw",
            height: "50vh",
          }}
          src={svg_background}
        ></img>
      </StyledImageContainer>
      <StyledTextContainer style={{}}>
        <div className="row">
          <StyledTitle
            className="col-7"
            style={{
              color: theme.COLORS.BLUE.darkBlueGreen,
              fontSize: getAdaptiveFontSize({
                screenWidthHooks,
                fontSize: 1.2,
              }),
            }}
          >
            {t(`${getFirstName()},`)}
            <br></br>
            {showFinalScore
              ? t("Your final evr-ratio Is:")
              : t("Your evr-ratio Is:")}
          </StyledTitle>
          <EvrScore showFinalScore={showFinalScore}> </EvrScore>
        </div>
        <StyledSubTitle
          className="col-9 text-center"
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: getAdaptiveFontSize({
              screenWidthHooks,
              fontSize: 1.6,
            }),
          }}
        >
          {t("Our Sleep Experts will")}
          <br></br>
          {t("build in ")}
          {getLayerString(bmi)}
        </StyledSubTitle>
        <ContainedButton
          className="col-auto"
          styles={{
            textTransform: "upperCase",
            fontSize: getAdaptiveFontSize({
              screenWidthHooks,
              fontSize: 0.8,
            }),
            marginTop: "4vh",
          }}
          onClick={() =>
            dispatch(setIsIncorporateModalOpen(!isIncorporateModalOpen))
          }
        >
          {t("How does this affect")}
          <br></br>
          {t("my evrbed?")}
        </ContainedButton>
      </StyledTextContainer>
    </div>
  );
};

export default EvrRatioModal;
